/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { FindSimilarMarketsByTextResponse, FindSimilarMarketsByTextVars } from '../openapi-types.gen.js';

export type { FindSimilarMarketsByTextResponse, FindSimilarMarketsByTextVars } from '../openapi-types.gen.js';

export const useFindSimilarMarketsByText = createMutationHook<FindSimilarMarketsByTextVars, FindSimilarMarketsByTextResponse, unknown>({
  specName: 'useFindSimilarMarketsByText',
  path: '/v1/markets/embeddings/similar',
  method: 'POST',
  resolveUrl: (vars: FindSimilarMarketsByTextVars) => `/v1/markets/embeddings/similar`,
  buildBody: (vars: FindSimilarMarketsByTextVars) => ({ query: vars.query, category: vars.category }),
  parseResponse: (raw: unknown): FindSimilarMarketsByTextResponse => raw as FindSimilarMarketsByTextResponse,
  
  
  
});
